import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

import { FormValidationsService } from '../utils/form-validations.service';

@Component({
  selector: 'app-field-control-error',
  templateUrl: './field-control-error.component.html',
  styleUrls: ['./field-control-error.component.scss'],
})
export class FieldControlErrorComponent {
  @Input() control: AbstractControl | null;
  @Input() label: string;
  @Input() isBootstrap = false;

  constructor(private formValidationsService: FormValidationsService) {}

  get errorMessage() {
    for (const propertyName in this.control?.errors) {
      if (
        this.control?.errors.hasOwnProperty(propertyName) &&
        this.control?.touched
      ) {
        return this.formValidationsService.getErrorMsg(
          this.label,
          propertyName,
          this.control?.errors[propertyName]
        );
      }
    }

    return null;
  }
}
